const HelperPriceRoutes = {
  createPrice: "/createPrice",
  getPrice: "/getPrice",
  updatePrice: "/updatePrice",
  deletePrice: "/deletePrice",
};

export default HelperPriceRoutes;
